import { inject, InjectionToken } from "@angular/core";
import { Route } from "@angular/router";
import { DynamicTabsService } from "@app/shared-core/general/dynamic-tabs/dynamic-tabs.service";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";
import { ExpirationSettingsRoutePaths } from "@app/applications/settings/domains/expiration-settings/expiration-settings-route-path";
import { ocrQuotationExpirationSettingsRoutes } from "../ocr-quotation-expiration-settings.routes";
import { OcrQuotaitonExpirationSettingsRoutePaths } from "../ocr-quotaiton-expiration-settings-route-path";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const ocrQuotationExpirationSettingsDynamicRoutesConfig: Route[] = [
  {
    path: ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
    children: [
      {
        path: "",
        children: [...ocrQuotationExpirationSettingsRoutes],
      },
    ],
  },
];

export const ADD_OCR_QUOTATION_EXPIRATION_SETTINGS_TABS = new InjectionToken("ADD_OCR_QUOTATION_EXPIRATION_SETTINGS_ROUTES", {
  providedIn: "root",
  factory: () => {
    inject(DynamicTabsService).addTabs(
      ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
      [
        {
          route: OcrQuotaitonExpirationSettingsRoutePaths.ROOT,
          label: "OCR_QUOTATION_EXPIRATION_SETTINGS.TITLES.OCR_QUOTATION_EXPIRATION_SETTINGS",
          permissions: [PERMISSION_CONSTANTS.OCR_QUOTATION_EXPIRATION_SETTINGS.VIEW, PERMISSION_CONSTANTS.OCR_QUOTATION_EXPIRATION_SETTINGS.SET],
        },
      ],
      { parentRoutePath: APP_ROUTE_PATHS.SETTINGS, routes: ocrQuotationExpirationSettingsDynamicRoutesConfig }
    );
  },
});
